import React from "react";
import "../styles/Footer.css";
import { useNavigate, useLocation } from "react-router-dom";

/* Logo */
import logo from "../assets/logo4.png";

/* Social icons */
import whatsappIcon from "../assets/whatsapp.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import mail from "../assets/mail.png";

/* Floating buttons */
import whatsapp from "../assets/whatsapp.png";

/* Back to top arrow */
import topArrow from "../assets/top1.png";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  // Back to top
  const goTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  // Smooth scroll + navigation (home sections)
  const handleNavClick = (e, id) => {
    e.preventDefault();

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="footer" id="contact">

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Maha Cabs",
          "image": "https://mahacabs.co/logo4.png",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "State Bank Road, Near Vijaya Theater",
            "addressLocality": "Mayiladuthurai",
            "postalCode": "609001",
            "addressCountry": "IN"
          },
          "telephone": "+919486589488",
          "email": "mahacabs82@gmail.com",
          "url": "https://mahacabs.co",
          "serviceOffered": "Cab Service, Taxi Service, Airport Transfers, Outstation Cabs"
        })}
      </script>
      {/* ================================================ */}

      <div className="footer-container">

        {/* Left Side */}
        <div className="footer-left">
          <div className="footer-brand">
            <img 
              src={logo} 
              alt="Maha Cabs Logo" 
              className="footer-logo"
              loading="lazy"
            />
            <p className="footer-slogan">
              "Safety First, Speed Next"
            </p>
          </div>

          <div className="footer-desc-col">
            <p className="footer-desc">
              Experience comfortable and luxury travel designed
              for family trips, tours, airport transfers, and
              business journeys with professional driver and
              well-maintained vehicles ensuring a smooth ride
              every time.
            </p>
          </div>
        </div>

        {/* Right Side */}
        <div className="footer-right">

          {/* Quick Links */}
          <div className="footer-col">
            <h3>Quick Links</h3>

            <nav aria-label="Footer Quick Links Navigation">
              <ul>
                <li>
                  <a 
                    href="#home" 
                    title="Go to Home Section"
                    onClick={(e) => handleNavClick(e, "home")}
                  >
                    Home
                  </a>
                </li>

                <li>
                  <a 
                    href="#about" 
                    title="Learn About Us"
                    onClick={(e) => handleNavClick(e, "about")}
                  >
                    About
                  </a>
                </li>

                <li>
                  <a 
                    href="#services" 
                    title="View Our Services"
                    onClick={(e) => handleNavClick(e, "services")}
                  >
                    Services
                  </a>
                </li>

                <li>
                  <a
                    href="/gallery"
                    title="View Our Gallery"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/gallery");
                    }}
                  >
                    Gallery
                  </a>
                </li>

                <li>
                  <a
                    href="/blog"
                    title="Read Our Blog"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/blog");
                    }}
                  >
                    Blog
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Location */}
          <div className="footer-col">
            <h3>Location</h3>
            <p>
              State Bank Road,<br />
              Near Vijaya Theater,<br />
              Mayiladuthurai - 609001
            </p>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h3>Contact Us</h3>

            <div className="social-icons">
              <a 
                href="https://api.whatsapp.com/send/?phone=%2B919486589488&text=Hii&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                title="Chat on WhatsApp"
              >
                <img src={whatsappIcon} alt="WhatsApp" loading="lazy" />
              </a>

              <a 
                href="https://www.instagram.com/mahacabs?igsh=M2t5Z2ExYmxnMnpv"
                target="_blank"
                rel="noopener noreferrer"
                title="Visit our Instagram"
              >
                <img src={insta} alt="Instagram" loading="lazy" />
              </a>

              <a 
                href="https://www.facebook.com/share/18fHRR8Y5j/"
                target="_blank"
                rel="noopener noreferrer"
                title="Visit our Facebook"
              >
                <img src={fb} alt="Facebook" loading="lazy" />
              </a>

              <a 
                href="mailto:mahacabs82@gmail.com"
                title="Email Maha Cabs"
              >
                <img src={mail} alt="Email" loading="lazy" />
              </a>
            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        ©2026 by MAHA CABS CREATED BY DD_DIGITAL_CONSTRUCTION
      </div>

      <a
        href="https://api.whatsapp.com/send/?phone=%2B919486589488&text=Hii&type=phone_number&app_absent=0"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
        aria-label="Chat with Maha Cabs on WhatsApp"
      >
        <img src={whatsapp} alt="WhatsApp Chat" loading="lazy" />
      </a>

      <button 
        className="back-top" 
        onClick={goTop}
        aria-label="Scroll to Top"
      >
        <img src={topArrow} alt="Back to top" loading="lazy" />
      </button>

    </footer>
  );
}
